import MainEdit from './Editor/MainEdit';
import CoverPage from './CoverPage';
import * as SizeFunctions from './utilities/SizeFunctions';
import * as StyleFunctions from './utilities/StyleFunctions';
import * as CoreFns from './utilities/CoreFns';
import React, {useState}  from 'react';
import MainNav from './MainNav';
import NormalBtn from './StockItems/NormalBtn';
import RunOrSimulate from './RunOrSimulate';
// import ClientDatabase from './ClientDatabase';
import VariableDatabase from './VariableDatabase';
import LaunchManager from './launch/LaunchManager';
import * as ActionModifiers from  './ActionModifiers';
import UrlParamSetter from './UrlParamSetter';

function App(props) {

  var homeButton = props.homeButton;
  var width = props.width;
  var height = props.height;
  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var otherPeoplesPositions = props.otherPeoplesPositions;
  var updatesToPropagate = props.updatesToPropagate;
  var error = props.error;
  var userNos = props.userNos;
  var currentPage = props.currentPage;
  var getHistoryWithDefaults = props.getHistoryWithDefaults;
  var logInState = props.logInState;
  var addToExtraScreen = props.addToExtraScreen;

  var setItemEdited = props.setItemEdited;
  var itemEdited = props.itemEdited;

  var nosCredits = props.nosCredits;
  var setNosCredits = props.setNosCredits;
  var history = props.history;
  var setHistory = props.setHistory;
  var userID = props.userID;
  var signKey = props.signKey;
  var sessionID = props.sessionID;
  var programSetID = props.programSetID;
  var clickBack = props.clickBack;
  var setSelectedStep = props.setSelectedStep;
  var tabSelected = props.tabSelected;
  var setTabSelected = props.setTabSelected;
  var changeTab = props.changeTab;
  var clickUndoRedo = props.clickUndoRedo;
  var isConnected = props.isConnected;
  var canRedo = props.canRedo;
  var canUndo = props.canUndo;
  var saveState = props.saveState;
  var doingWhat = props.doingWhat;
  var setDoingWhat = props.setDoingWhat;
  var refObject = props.refObject;
  var setRefObject = props.setRefObject;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var setHidePanelRelativeItems = props.setHidePanelRelativeItems;
  var hidePanelRelativeItems = props.hidePanelRelativeItems;
  var accessLevel = props.accessLevel;
  var simplDuplicate = props.simplDuplicate;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;

  var screenSize = props.screenSize;
  var setScreenSize = props.setScreenSize;
  var detailsWidth = props.detailsWidth;
  var setDetailsWidth = props.setDetailsWidth;
  var zoom = props.zoom;
  var setZoom = props.setZoom;
  var resetZoom = props.resetZoom;
  var translateX = props.translateX;
  var setTranslateX = props.setTranslateX;
  var translateY = props.translateY;
  var setTranslateY = props.setTranslateY;
  var navBarHeight = props.navBarHeight;
  var setNavBarHeight = props.setNavBarHeight;
  var tabWidth = props.tabWidth;
  var centerZoom = props.centerZoom;
  var scrollableElement = props.scrollableElement;
  var isGone = props.isGone;
  var tempAddr = props.tempAddr;
  var setTempAddr = props.setTempAddr;
  var heightsOfPages = props.heightsOfPages;
  var setHeightsOfPages = props.setHeightsOfPages;
  var chains = props.chains;
  var palette = props.palette;
  var itemCategories = props.itemCategories;

  const [mostRecentFont, setMostRecentFont] = useState('');
  const [mostRecentColor, setMostRecentColor] = useState('');
  const [isShowDatabase, setIsShowDatabase] = useState(false);
  const [ownVariablesForPreview, setOwnVariablesForPreview] = useState({})
  const [urlParamsForPreview, setUrlParamsForPreview] = useState([]);

  var urlParamsForExecution = CoreFns.paramLine(urlParamsForPreview);

  function changeShowWhat(newShowWhat){
    return function(e){
      if (doingWhat && doingWhat.t === 'guide' && doingWhat.v === 6 && newShowWhat === 'pr'){
        window.alert('Congratulations! You have completed the tutorial.');
        setDoingWhat(false);
      }
      setIsShowDatabase(false);
      setSelectedStep([newShowWhat]);
    }
  }
  var currentSStep = '';
  if (currentPage.length > 0){
    currentSStep = currentPage[0];
  }

  var controlStyle = {};

  var contentsHeight = height - navBarHeight;


  var navContents = <MainNav homeButton={homeButton} currentList={currentList} organicChanges={organicChanges} currentPage={currentPage} getHistoryWithDefaults={getHistoryWithDefaults} logInState={logInState} addToExtraScreen={addToExtraScreen} currentSStep={currentSStep} changeShowWhat={changeShowWhat} screenSize={screenSize} setScreenSize={setScreenSize} clickUndoRedo={clickUndoRedo} isConnected={isConnected} canUndo={canUndo} canRedo={canRedo} saveState={saveState} isShowDatabase={isShowDatabase} setIsShowDatabase={setIsShowDatabase} doingWhat={doingWhat} error={error} zoom={zoom} setZoom={setZoom} centerZoom={centerZoom} isGone={isGone} clickBack={clickBack}
  />

  var errorLoc = '';
  if (error.loc){
    errorLoc = error.loc[0];
  }

  var frontEnds = currentList.fe;
  var feKeys = Object.keys(frontEnds);

  var contents;

  function doOpps(mainMsg, goWhere){
    return <div className="container">
      <div className="row mb-4">
        <div className="col-lg-8 mx-auto text-center">
          <p className="lead mb-0"><b>Oops</b></p>
          <p className="lead mb-0">{mainMsg}</p>
          <NormalBtn onClick={changeShowWhat(goWhere)} title='Click here to do so'/>
        </div>
      </div>
      </div> 
  }
//
  if (isGone){
    contents = <div className='lead mb-0' style={{margin:'10px'}}>Apologies, the edits triggered a database error that prevents your future work from further saves. Please reload this page and try again. If this persists, please contact us via Telegram @cuessg and we will help fix this. Sorry about that.</div>
//
  }else if (currentSStep === 'edit'){
    contents = <MainEdit chains={chains} detailsWidth={detailsWidth} setDetailsWidth={setDetailsWidth} centerZoom={centerZoom} tabWidth={tabWidth} setItemEdited={setItemEdited} itemEdited={itemEdited} width={width} height={contentsHeight} currentList={currentList} organicChanges={organicChanges} userNos={userNos} otherPeoplesPositions={otherPeoplesPositions} updatesToPropagate={updatesToPropagate} error={error} addToExtraScreen={addToExtraScreen}  tabSelected={tabSelected} setTabSelected={setTabSelected} changeTab={changeTab} userID={userID} sessionID={sessionID} signKey={signKey} logInState={logInState} screenSize={screenSize} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} doingWhat={doingWhat} setDoingWhat={setDoingWhat} isClickingOnContentDiv={isClickingOnContentDiv} setIsClickingOnContentDiv={setIsClickingOnContentDiv} refObject={refObject} setRefObject={setRefObject}  setHidePanelRelativeItems={setHidePanelRelativeItems} hidePanelRelativeItems={hidePanelRelativeItems} setIsShowingSomeDropDown={setIsShowingSomeDropDown} isShowingSomeDropDown={isShowingSomeDropDown} zoom={zoom} translateX={translateX} resetZoom={resetZoom} translateY={translateY} setTranslateX={setTranslateX} setTranslateY={setTranslateY} urlParamsForExecution={urlParamsForExecution} scrollableElement={scrollableElement} tempAddr={tempAddr} setTempAddr={setTempAddr} heightsOfPages={heightsOfPages} setHeightsOfPages={setHeightsOfPages} palette={palette} itemCategories={itemCategories} programSetID={programSetID}
/>

  }else if (errorLoc === 'fe' || errorLoc === 'pu' || errorLoc === 'as'){
    contents = doOpps('Please resolve the issues in the design first.', 'edit');
  }else if (feKeys.length === 0){
    contents = doOpps('Please design your dapp first.', 'edit');
  }else if (currentSStep === 'pr'){

    var p = ActionModifiers.actionMods(currentList, [], 'placeholder', chains, changeTab);
    if (p.length > 0){
      contents = doOpps('Please fill up your placeholders first.', 'edit');
//      
    // }else if (isShowDatabase === 'client'){
    //   contents = <div style={{overflow:'scroll', width, height:height - navBarHeight}}><ClientDatabase programSetID={programSetID} userID={userID} signKey={signKey} sessionID={sessionID} color='white' showIfNothing={true}/></div>
    }else if (isShowDatabase === 'url'){
      contents = <div style={{overflow:'scroll', width, height:height - navBarHeight}}><UrlParamSetter urlParamsForPreview={urlParamsForPreview} setUrlParamsForPreview={setUrlParamsForPreview} /></div>
    }else if (isShowDatabase === 'variables'){
      contents = <div style={{overflow:'scroll', width, height:height - navBarHeight}}><VariableDatabase currentList={currentList} ownVariables={ownVariablesForPreview} color='white'/></div>
//
    }else{
      var ssSizes = StyleFunctions.screenWidthsAndHeights(screenSize);
      var insetWidth = ssSizes.insetWidth;
      var insetHeight = ssSizes.insetHeight;
      var oL = (width - insetWidth - 1)/2;
      var oT = navBarHeight + 1;

      var relevantLaunchInfo = CoreFns.getRelevantLaunchInfo(history, programSetID);
      var currentUrl = 'https://www.cues.sg/dapps/XXXX';
      if (relevantLaunchInfo){
        currentUrl = 'https://www.cues.sg/dapps/'+ relevantLaunchInfo.v[5].v;
      }
      contents = <div style={{overflow:'scroll', width, height:height - navBarHeight, padding:'10px'}}><center><div style={{border:'1px solid black', width:insetWidth + 2, height:insetHeight + 2}}><RunOrSimulate chains={chains} overallWidth={width} currentList={currentList} width={insetWidth} height={insetHeight} overlays={null} programSetID={programSetID} ownVariables={ownVariablesForPreview} setOwnVariables={setOwnVariablesForPreview} urlParamsForExecution={urlParamsForExecution} run={true} offsetTop={oT} offsetLeft={oL} urlHeader={currentUrl}/></div></center></div>

    }

//
  }else if (currentSStep === 'de'){

    contents = <div style={{backgroundColor:'#000000A0', position:'absolute', zIndex:140, left:0, right:0, top:0, bottom:0}}><div style={{backgroundColor:'#FFFFFF', position:'absolute', left:10, right:10, top:10, bottom:10, overflowY:'scroll'}}><LaunchManager chains={chains} selectedStep={currentPage} setSelectedStep={setSelectedStep} programSetID={programSetID} sessionID={sessionID} userID={userID} signKey={signKey} width={width} currentList={currentList} nosCredits={nosCredits} setNosCredits={setNosCredits} history={history} getHistoryWithDefaults={getHistoryWithDefaults} setHistory={setHistory} logInState={logInState} addToExtraScreen={addToExtraScreen} clickBack={clickBack} height={contentsHeight-20} simplDuplicate={simplDuplicate} accessLevel={accessLevel} changeShowWhat={changeShowWhat} changeTab={changeTab} /></div></div>

    controlStyle.height = '100%';
    controlStyle.overflowY = 'hidden';
  
  }


  return <div style={controlStyle}>
    <CoverPage contents={navContents} reportHeight={SizeFunctions.updateSubsetDimensions(setNavBarHeight)} />

    {contents}
  </div>


}

export default App;
